import useStrings from "../../../../localization/useStrings"
import svg from "../../../../utils/svg"
import {
  FeatureAlert,
  useUltimateAlerts,
} from "../../../../context/ultimateAlertsContext"
import styles from "../FeaturesList/FeaturesList.module.scss"
import { SeasonalPaywallColors } from "../../SeasonalPaywall"

interface Feature {
  icon: React.ReactNode
  title: string
  description: string
  alert?: FeatureAlert
}

interface UltimateFeaturesListProps {
  colors: SeasonalPaywallColors
}

const UltimateFeaturesList = ({ colors }: UltimateFeaturesListProps) => {
  const strings = useStrings()
  const { actions } = useUltimateAlerts()

  const features: Feature[] = [
    {
      icon: (
        <svg.featureIcons.CloudVault style={{ fill: colors.features.icon }} />
      ),
      title: strings.premiumToUltimateBlackFriday.cloud.title,
      description: strings.premiumToUltimateBlackFriday.cloud.description,
    },
    {
      icon: (
        <svg.featureIcons.DuplicateDetection
          style={{ fill: colors.features.icon }}
        />
      ),
      title: strings.features.duplicateDetection,
      description:
        strings.premiumToUltimateBlackFriday.duplicateDetection.description,
    },
    {
      icon: (
        <svg.featureIcons.OrganizationPlus
          style={{ fill: colors.features.icon }}
        />
      ),
      title: strings.features.organizationPlus,
      description:
        strings.premiumToUltimateBlackFriday.organizationPlus.description,
      alert: "organization+",
    },
    {
      icon: (
        <svg.featureIcons.SecurityPlus style={{ fill: colors.features.icon }} />
      ),
      title: strings.features.securityPlus,
      description:
        strings.premiumToUltimateBlackFriday.securityPlus.description,
      alert: "security+",
    },
  ]

  return (
    <div className={styles.container}>
      {features.map((feature, index) => (
        <div key={index} className={styles.featureItem}>
          <div className={styles.icon}>{feature.icon}</div>
          <div className={styles.content}>
            <div className={styles.titleContainer}>
              <h3
                className={styles.title}
                style={{ color: colors.features.title }}
              >
                {feature.title}
              </h3>
              {feature.alert && (
                <button
                  className={styles.infoButton}
                  onClick={() => actions.setShowFeatureAlert(feature.alert!)}
                >
                  <svg.Info className={styles.infoIcon} />
                </button>
              )}
            </div>
            <p
              className={styles.ultimateDescription}
              style={{ color: colors.features.description }}
            >
              {feature.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default UltimateFeaturesList
